export function formatPointTooltip(
  pointName: string | null | undefined,
): string {
  if (!pointName) {
    return '';
  }

  const idx = pointName.indexOf('(');

  if (idx <= 0) {
    return pointName;
  }

  const name = pointName.slice(0, idx).trim();
  const insideParens = pointName.slice(idx + 1, -1).trim();

  return `${insideParens} (${name})`;
}
